import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import { api_path } from "../../environment";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: {
    urlPiece?: string;
    academicYear?: string;
  };
  onClose: () => void;
};
const ExternalModalApercu = ({ show, metaData, onClose }: Props) => {
  const [fileType, setFileType] = useState<"pdf" | "image" | "unknown">(
    "unknown",
  );
  // 🔽 Personnalisation du nom du fichier
  useEffect(() => {
    if (metaData?.urlPiece) {
      const ext = metaData.urlPiece.split(".").pop()?.toLowerCase();
      setFileType(
        ext === "pdf"
          ? "pdf"
          : ["jpg", "jpeg", "png"].includes(ext || "")
            ? "image"
            : "unknown",
      );
    }
  }, [metaData]);

  const handleDownload = () => {
    if (!metaData?.urlPiece) return;

    const a = document.createElement("a");
    a.href = `${api_path}/api/extern/file/${metaData.urlPiece}`;
    a.download = `Pièces_${metaData?.academicYear || "Annee"}.${metaData.urlPiece.split(".").pop()}`;
    a.click();
  };

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Aperçu du relevé de note</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={`${api_path}/api/extern/file/${metaData?.urlPiece}`}
            style={{ width: "100%", height: "100%" }}
            title="Aperçu PDF"
            // sandbox="allow-same-origin"
            onError={(e) => {
              // console.error("Erreur de chargement du PDF", e);
              // Affichez un message d'erreur si nécessaire
            }}
          />
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button
            className="btn btn-primary"
            onClick={handleDownload}
            disabled={!metaData?.urlPiece}
          >
            Télécharger
          </button>
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  ExternalModalApercu,
  [buildPermission(Resource.EXTERNAL_NOTE, Action.UPDATE)],
  "masquer",
);
